import { NgModule, isDevMode, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withInterceptors } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// icons
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';

// perfect scrollbar
import { NgScrollbarModule } from 'ngx-scrollbar';

//Import all material modules
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//Import Layouts
import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { FilterPipe } from './pipe/filter.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CommonModule, registerLocaleData } from '@angular/common';
import { ServiceWorkerModule } from '@angular/service-worker';
import localeEsCl from '@angular/common/locales/es-CL';
import loacleEsClExtra from '@angular/common/locales/extra/es-CL';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { CookieService } from 'ngx-cookie-service';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { TokenInterceptor } from './services/token.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { MatSliderModule } from '@angular/material/slider';
import { MatRippleModule } from '@angular/material/core';
import { MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';


import { IConfig, NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask, provideNgxMask,  } from 'ngx-mask';
import { TextEditorComponent } from './common/components/text-editor/text-editor.component';


const maskConfig: Partial<IConfig> = {
  validation: false,
  thousandSeparator:"."
};
export function HttpLoaderFactory(http: HttpClient): any {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

//registerLocaleData(localeEsCl, 'es-CL', loacleEsClExtra);
registerLocaleData(localeEsCl, 'es-CL');


@NgModule({
  declarations: [AppComponent, BlankComponent, FilterPipe, TextEditorComponent],
  imports: [
    RouterModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    CommonModule,
    NgxMaskDirective,
    MaterialModule,
    MatSliderModule,
    MatRippleModule,
    NgxMaskDirective, NgxMaskPipe,
    ToastrModule.forRoot(),
    TablerIconsModule.pick(TablerIcons),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgScrollbarModule,
    FullComponent,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    })
  ],

  providers: [
    { provide: LOCALE_ID, useValue: 'es-CL' },
    CookieService,
    provideHttpClient(withInterceptorsFromDi()),
    provideOAuthClient(),
    { provide: MAT_DATE_LOCALE, useValue: 'es-CL' },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    provideNgxMask(maskConfig),
    provideEnvironmentNgxMask(maskConfig),
  ],
  exports: [TablerIconsModule],
  bootstrap: [AppComponent],
})
export class AppModule {}
